import { render, staticRenderFns } from "./AdminApproval.vue?vue&type=template&id=7906d54f"
import script from "./AdminApproval.vue?vue&type=script&lang=js"
export * from "./AdminApproval.vue?vue&type=script&lang=js"
import style0 from "./AdminApproval.vue?vue&type=style&index=0&id=7906d54f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports